import Restaurant from '@/screens/settings/Restaurant'
import Provider from '@/screens/settings/Provider'
import ProviderBank from '@/screens/settings/ProviderBank'
import ProviderNotification from '@/screens/settings/ProviderNotification'
import ProviderDelivery from '@/screens/settings/ProviderDelivery'

import auth from './middleware/auth'

const routes = [
  {
    path: '/settings',
    component: {
      render: r => r('router-view')
    },
    children: [
      {
        path: 'restaurant',
        name: 'RestaurantSettings',
        component: Restaurant,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'provider',
        name: 'ProviderSettings',
        component: Provider,
        meta: {
          requireAuth: true,
          permissions: ['provider'],
          middleware: { auth }
        }
      },
      {
        path: 'provider-bank',
        name: 'ProviderBank',
        component: ProviderBank,
        meta: {
          requireAuth: true,
          permissions: ['provider'],
          middleware: { auth }
        }
      },
      {
        path: 'provider-notification',
        name: 'ProviderNotification',
        component: ProviderNotification,
        meta: {
          requireAuth: true,
          permissions: ['provider'],
          middleware: { auth }
        }
      },
      {
        path: 'provider-delivery',
        name: 'ProviderDelivery',
        component: ProviderDelivery,
        meta: {
          requireAuth: true,
          permissions: ['provider'],
          middleware: { auth }
        }
      }
    ]
  },
  {
    path: '/integrations',
    children: [
      {
        path: 'facebook/success',
        redirect: { name: 'RestaurantSettings', query: { 'loged-from': 'facebook' } },
        component: {
          render: r => r('router-view')
        }
      },
      {
        path: 'facebook/error',
        redirect: { name: 'RestaurantSettings', query: { 'error-from': 'facebook' } },
        component: {
          render: r => r('router-view')
        }
      },
      {
        path: 'foursquare/success',
        redirect: { name: 'RestaurantSettings', query: { 'loged-from': 'foursquare' } },
        component: {
          render: r => r('router-view')
        }
      },
      {
        path: 'foursquare/error',
        redirect: { name: 'RestaurantSettings', query: { 'error-from': 'foursquare' } },
        component: {
          render: r => r('router-view')
        }
      }
    ]
  }
]

export default routes
